import { render, staticRenderFns } from "./Technician.vue?vue&type=template&id=2c2a6e1d&scoped=true&"
import script from "./Technician.vue?vue&type=script&lang=js&"
export * from "./Technician.vue?vue&type=script&lang=js&"
import style0 from "./Technician.vue?vue&type=style&index=0&id=2c2a6e1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2a6e1d",
  null
  
)

export default component.exports